import { Market } from '@oneaudi/avp-models';

export const cupraConfiguratorSites: Map<string, string> = new Map()
  .set(Market.DEU, 'https://www.cupraofficial.de/konfigurator.html/summary?wf=cupra-de')
  .set(Market.ESP, 'https://www.cupraofficial.es/configurador.html/summary?wf=cupra-es')
  .set(Market.GBR, 'https://www.cupraofficial.co.uk/configurator.html/summary?wf=cupra-uk');

export const cupraLegalNoticeSites: Map<string, string> = new Map()
  .set(Market.DEU, 'https://www.cupraofficial.de/rechtlicherhinweis')
  .set(Market.ESP, 'https://www.cupraofficial.es/nota-legal')
  .set(Market.GBR, 'https://www.cupraofficial.co.uk/legal-note');
